// Replaces identifier-like URL segments with placeholders so PostHog groups
// pageviews by route shape (e.g. /portal/journey/:id) instead of exploding
// into one entry per journey — and so raw IDs/tokens never leave the browser.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const OBJECT_ID = /^[0-9a-f]{24}$/i;
const NUMERIC = /^\d+$/;

export const sanitizePath = (pathname: string): string =>
  pathname
    .split('/')
    .map((segment) => {
      if (!segment) return segment;
      if (
        UUID.test(segment) ||
        OBJECT_ID.test(segment) ||
        NUMERIC.test(segment)
      )
        return ':id';
      // Long opaque strings (register/reset JWTs, etc.).
      if (segment.length > 32) return ':token';
      return segment;
    })
    .join('/');
